jQuery(document).ready(function () {
    jQuery('ul.dropdown.menu.mainmenu li.index a').html('<i class="fas fa-home"></i>');
    if (Foundation.MediaQuery.atLeast('large')) {
        jQuery(window).scroll(function () {
            if (jQuery("header").offset().top - jQuery(window).scrollTop() <= 0) {
                jQuery("header").addClass("on");
            }
            if ($(window).scrollTop() === 0) {
                jQuery("header").removeClass("on");
            }
        });
    }
    if (jQuery('.slider').length > 0) {
        jQuery('.slider').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: true,
            autoplay: true,
        });
    }
    CzBox.create();
    jQuery('.recherche > a ').on('click', function (e) {
        e.preventDefault();
        jQuery('#modalsearch').foundation('open');
    });
    jQuery('.bt_top').on('click', function (event) {
        event.preventDefault();
        jQuery('body, html').stop().animate({ scrollTop: 0 }, 800);
    });
    jQuery('.footer-menu__open-menu').on('click', function () {
        jQuery('.footer-menu__content').toggleClass('show');
        jQuery('.footer-menu').toggleClass('open');
    });
});